import {Block, Row} from 'jsxstyle'
import React, {useEffect, useState} from 'react'
import {motion, AnimatePresence} from 'framer-motion'

export type ToastProps = {
  message: string
  color?: string
  backgroundColor?: string
  duration?: number
  showToast: boolean
  setShowToast: (show: boolean) => void
}

const Toast: React.FC<ToastProps> = ({message, color = '#0066DB', backgroundColor = '#EAF3FF', duration = 3000, showToast, setShowToast}) => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowToast(false)
    }, duration)
    return () => clearTimeout(timeout)
  }, [showToast])

  return (
    <Block top="20px" right="20px" zIndex={1000}>
      <AnimatePresence>
        {showToast && (
          <motion.div
            initial={{x: 300, y: 0, opacity: 0}}
            animate={{x: 0, y: 0, opacity: 1}}
            exit={{x: 300, y: 0, opacity: 0}}
            transition={{duration: 0.3}}
            style={{position: 'absolute', top: 40, right: 20, left: 'auto'}}
          >
            <Row
              color={color}
              backgroundColor={backgroundColor}
              borderRadius="8px"
              padding="16px 20px"
              justifyContent="space-between"
              alignItems="center"
              boxShadow="0px 2px 8px rgba(0,0,0,0.2)"
            >
              {message}

              <Block color={color} marginLeft="12px" fontWeight="bold" cursor="pointer" props={{onClick: () => setShowToast(false)}}>
                ✕
              </Block>
            </Row>
          </motion.div>
        )}
      </AnimatePresence>
    </Block>
  )
}

export default Toast
